import ActionsCell from "./ActionsCell";

export const columns = [
  {
    Header: "Nombre",
    accessor: "alias",
    filterable: true,
    filterMethod: (filter, row) => {
      return (row.alias || "")
        .toString()
        .toLowerCase()
        .includes(filter.value.toLowerCase());
    },
  },
  {
    Header: "Codigo",
    accessor: "code",
    filterable: true,
    filterMethod: (filter, row) => {
      return (row.code || "")
        .toString()
        .toLowerCase()
        .includes(filter.value.toLowerCase());
    },
  },
  {
    Header: "Telefono",
    accessor: "localPhone",
    filterable: true,
    filterMethod: (filter, row) => {
      return (row.localPhone || "")
        .toString()
        .toLowerCase()
        .includes(filter.value.toLowerCase());
    },
  },
  {
    Header: "RFC",
    accessor: "rfc",
    filterable: true,
    filterMethod: (filter, row) => {
      return (row.rfc || "")
        .toString()
        .toLowerCase()
        .includes(filter.value.toLowerCase());
    },
  },
  {
    Header: "Planta",
    accessor: "station",
    filterable: true,
    filterMethod: (filter, row) => {
      return (row.station || "")
        .toString()
        .toLowerCase()
        .includes(filter.value.toLowerCase());
    },
  },
  {
    Header: "Tipo",
    accessor: "type",
    filterable: true,
    filterMethod: (filter, row) => {
      return (row.type || "")
        .toString()
        .toLowerCase()
        .includes(filter.value.toLowerCase());
    },
  },
  {
    Header: "Dirección",
    accessor: "fullAddress",
    filterable: true,
    filterMethod: (filter, row) => {
      return (row.fullAddress || "")
        .toString()
        .toLowerCase()
        .includes(filter.value.toLowerCase());
    },
  },
  {
    Header: "Acciones",
    Cell: ActionsCell,
  },
];
